import "core-js/modules/es.string.starts-with";
//
//
//
//
//
//
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
export default {
  name: "cpt-button",
  props: {
    option: Object
  },
  data: function data() {
    return {
      cptData: {},
      uuid: null
    };
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshCptData();
  },
  methods: {
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm).then(function (res) {
        _this.cptData = res;
      });
    },
    redirect: function redirect() {
      if (this.option.attribute.url) {
        if (this.option.attribute.url.startsWith("view")) {
          this.$router.push(this.option.attribute.url);
          this.$emit("reload");
        } else {
          window.open(this.option.attribute.url);
        }
      }
    }
  }
};